module.exports = __webpack_public_path__ + "img/unknown-add.b4481443.svg";